
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as GeometryIconComponent } from "./geometry-icon.svg";

export const GeometryIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <GeometryIconComponent {...props} />;
};
